jQuery(document).ready(function ($) {
    const $blocks = $('.wp-block-jormi-blocks-immersive-section');

    if ($blocks.length === 0 || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    $blocks.each(function () {
        const $block = $(this);
        const $photoCol = $block.find('.jormi-immersive-section__photo-col');
        const $inner = $block.find('.jormi-immersive-section__inner');
        const $navItems = $block.find('.jormi-immersive-section__nav-item');

        // Fade the whole inner section in on scroll entry
        gsap.timeline({
            scrollTrigger: {
                trigger: $inner[0],
                start: 'top bottom-=200px',
                end: '+=500',
                scrub: true,
            },
        })
            .to($inner, { opacity: 1 })
            .to($block.find('.jormi-immersive-section__nav'), { top: '25vh' })
            .to($navItems.eq(0), { opacity: 1 });

        // Nav item transitions per content item
        const $contentItems = $block.find('.jormi-immersive-section__content-item');

        $contentItems.each(function (index) {
            if (index === 0) return; // first item handled above

            const trigger = this;
            const prevNavItem = $navItems.eq(index - 1);
            const currentNavItem = $navItems.eq(index);

            if (!trigger || !currentNavItem.length) return;

            gsap.timeline({
                scrollTrigger: {
                    trigger,
                    start: 'top bottom-=200px',
                    end: '+=500',
                    scrub: true,
                },
            })
                .to(prevNavItem, { opacity: 0.2 })
                .to(currentNavItem, { opacity: 1 });
        });

        // Fade out on exit
        gsap.timeline({
            scrollTrigger: {
                trigger: $inner[0],
                start: 'bottom center',
                end: '+=500',
                scrub: true,
            },
        })
            .to($inner, { opacity: 0 })
            .to($navItems, { opacity: 0.2 });

        // Photo swap — now dynamic, not hardcoded to 4
        $contentItems.each(function (index) {
            const content = this;
            const $photo = $photoCol.find(`.jormi-immersive-section__photo--${index + 1}`);

            if (!content || !$photo.length) return;

            gsap.set($photo, { opacity: 0 });

            ScrollTrigger.create({
                trigger: content,
                start: 'center bottom',
                end: 'center top',
                onToggle: (self) => {
                    gsap.to($photo, {
                        opacity: self.isActive ? 1 : 0,
                        duration: 0.5,
                    });
                },
            });
        });
    });
});